import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_friend.png"
import emptyWechat from "assets/images/ugifts/icons/empty/empty_wechat.png"
import emptyInvitation from "assets/images/ugifts/icons/empty/empty_invitation.png"

import { isIOS, isAndroid } from "react-device-detect"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import iconAppstore from "assets/images/ugifts/icons/app-store.png"
import iconPlaystore from "assets/images/ugifts/icons/google-play.png"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

function isWechat() {
  if (
    navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ||
    typeof navigator.wxuserAgent !== "undefined"
  ) {
    return true
  } else return false
}

const InviteLink = props => {
  const query = useQuery()
  const history = useHistory()
  const isWechatBrowser = isWechat()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [listType, setListType] = useState("active")
  const [oid, setOid] = useState(null)
  const [referral, setReferral] = useState(null)
  const [source, setSource] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    } else {
      setUid(0)
    }

    if (query.get("id")) {
      setOid(query.get("id"))
    }

    if (query.get("referral")) {
      setReferral(query.get("referral"))
    }

    if (query.get("source")) {
      setSource(query.get("source"))
    }

    if (isIOS) {
      window.open("https://apps.apple.com/us/app/ugift-global/id1603585098")
    }

    if (isAndroid) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.ebuy.ugift"
      )
    }
  }, [])

  useEffect(() => {
    if (source) {
      submitSource()
    }
  }, [source])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  const submitSource = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "track_link")
    urlencoded.append("source", source)
    urlencoded.append("member_id", uid)
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Submit track link", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      console.log(response.status, postresponse)
    }
  }

  useEffect(() => {
    if (referral) {
      window.open("ugift://?referral=" + referral, "_self")
    }
  }, [referral])

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: isWechatBrowser ? "0px" : "24px",
                  backgroundColor: "#63a7e7",
                  paddingBottom: "24px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    {/* {!isWechatBrowser && (
                      <Row
                        className="m-0 w-100"
                        style={{
                          height: "56px",
                          backgroundColor: "#63a7e7",
                          position: "fixed",
                          top: 0,
                          zIndex: 1030,
                          maxWidth: "480px",
                        }}
                      >
                        <Col xs={2} className="ps-0">
                        </Col>
                        <Col xs={8} className="align-self-center">
                          <p className="h-100 text-white font-size-15 my-auto text-center">
                            {""}
                          </p>
                        </Col>
                        <Col xs={2} className="pe-0">
                        </Col>
                      </Row>
                    )} */}
                    <Row className="px-3">
                      <Col style={{ textAlign: "center" }}>
                        <Label className="text-black font-size-28 my-auto mx-3 text-center font-weight-bold">
                          <strong>{"Welcome to Ugift"}</strong>
                        </Label>
                      </Col>
                    </Row>
                    {isWechatBrowser ? (
                      <UgiftEmptyState
                        image={emptyWechat}
                        title={props.t(
                          "Please browse this page using your phone's browser"
                        )}
                        link={null}
                        linkText={props.t("Back to Home")}
                      />
                    ) : (
                      <Row>
                        <Col>
                          <Card
                            className="mb-0 shadow-none p-0"
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "transparent",
                            }}
                          >
                            <CardImg
                              top
                              className="img-fluid"
                              src={emptyInvitation}
                              alt=""
                              // style={{
                              //   // aspectRatio: "3/2",
                              //   objectFit: "cover",
                              // }}
                            />
                          </Card>
                          {/* <UgiftEmptyState
                            image={emptyInvitation}
                            title={
                              referral
                                ? "Use " + referral + " as referral code"
                                : ""
                            }
                            link={null}
                            linkText={"Download On Apple Appstore"}
                          /> */}
                        </Col>
                      </Row>
                    )}
                    <Row className="px-3 mb-3">
                      <Col style={{ textAlign: "center" }}>
                        <p className="text-black font-size-20 my-auto mx-3 text-center">
                          {
                            "Explore the ease and delight of the Ugift App! Send personalised eCards and find the perfect gift with just a few taps. No more searching for separate options - Ugift brings it all to your fingertips. Download the app now for heartfelt gestures and thoughtful presents!"
                          }
                        </p>
                      </Col>
                    </Row>
                    {/* {!isIOS && !isAndroid && ( */}
                    <Row className="px-3">
                      <Col>
                        <Row
                          className="px-3"
                          style={{
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={iconAppstore}
                            // className="mt-2 mb-1"
                            alt=""
                            style={{
                              // width: "139px",
                              // height: "46px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              window.open(
                                "https://apps.apple.com/us/app/ugift-global/id1603585098"
                              )
                            }}
                          />
                          {/* <button
                            className="btn btn-dark font-size-15 p-0"
                            onClick={() => {
                              window.open(
                                "https://play.google.com/store/apps/details?id=com.ebuy.ugift"
                              )
                            }}
                          >
                            <i className="fab fa-google-play me-2" />
                            {"Google Playstore"}
                          </button> */}
                        </Row>
                      </Col>
                      <Col>
                        <Row
                          className="px-3"
                          style={{
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={iconPlaystore}
                            // className="mt-2 mb-1"
                            alt=""
                            style={{
                              // width: "152px",
                              // height: "46px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              window.open(
                                "https://play.google.com/store/apps/details?id=com.ebuy.ugift"
                              )
                            }}
                          />
                          {/* <button
                            className="btn btn-dark font-size-15 p-0"
                            onClick={() => {
                              window.open(
                                "https://play.google.com/store/apps/details?id=com.ebuy.ugift"
                              )
                            }}
                          >
                            <i className="fab fa-google-play me-2" />
                            {"Google Playstore"}
                          </button> */}
                        </Row>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col style={{ textAlign: "center" }}>
                        <Link
                          className="text-black font-size-15 my-auto text-center"
                          // style={{ height: "42px" }}
                          onClick={() => {
                            window.open(
                              "https://docs.google.com/document/d/17owHFlbPyvirnTdcokcEHEWh5idRLQqOzxvlxNfZPjQ/edit"
                            )
                          }}
                        >
                          {"Privacy Policy"}
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(InviteLink)

InviteLink.propTypes = {
  t: PropTypes.any,
}
